import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LanguageSelector from './LanguageSelector.js';
import Test from './Test.js';
import PriceUpdatation from './PriceUpdatation';



function App() {
  return (
    <Router>
      
        <Routes>
		  <Route path="/" element={<LanguageSelector />} />
      <Route path="/test" element={<Test />} />
      <Route path="/price_updataion" element={<PriceUpdatation />} />
          
        </Routes>
      
    </Router>
  );
}

export default App;